import type { DeviceFragment } from '@cobliteam/api-lib/src/__generated__/graphql';
import { formatDeviceStatusEventLabel, getDeviceDelay } from '@cobliteam/common-types';

const useSignalTicketEvent = (device?: DeviceFragment) => {
  const lastLocation = device?.lastLocation;
  const deviceId = device?.id;
  const deviceType = device?.generalType;
  const deviceStatus = device?.generalStatus;
  const { delayInMillis } = getDeviceDelay(lastLocation);

  const deviceStatusEventLabel = formatDeviceStatusEventLabel(deviceStatus);

  if (device) {
    return {
      deviceId,
      deviceType,
      timeInMillisSinceLastUpdate: delayInMillis,
      deviceStatus: deviceStatusEventLabel,
    };
  }

  return undefined;
};

export default useSignalTicketEvent;
